import keyMirror from 'fbjs/lib/keyMirror'

export default keyMirror({
  RECEIVED_HOOK_LOGIC_PRODUCTS: null,
  SHOW_HOOK_LOGIC_PRODUCTS: null,
  HIDE_HOOK_LOGIC_PRODUCTS: null,
  BEACON_SENT: null,
  CLEAR_HOOK_LOGIC_PRODUCTS: null,

  RECEIVED_HOOK_LOGIC_PRODUCTS_SAGA: null,
  SHOW_HOOK_LOGIC_PRODUCTS_SAGA: null,
  HIDE_HOOK_LOGIC_PRODUCTS_SAGA: null,
  BEACON_SENT_SAGA: null,
  CLEAR_HOOK_LOGIC_PRODUCTS_SAGA: null
})
